/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';

export const fetchIndustry = createAsyncThunk(
  'survey_login/post',
  async (arg, thunkAPI) => {
    const res = await client.post(`${apiUrl}industry`);
    return res.data;
  }
);

export const fetchPremiumRegister = createAsyncThunk(
  'checkout/post',
  async (arg, thunkApi) => {
    const {
      plan,
      amazonPeriod,
      rakutenPeriod,
      yahooPeriod,
      userId,
      password,
      paymentMethod,
      corporateNumber,
      industry,
      campaign
    } = arg;
    const res = await client.post(`${apiUrl}premium_register`, {
      plan,
      amazonPeriod,
      rakutenPeriod,
      yahooPeriod,
      login_id: userId,
      password,
      paymentMethod,
      corporateNumber,
      industry,
      campaign
    });
    return res.data;
  }
);

const premiumRegister = createSlice({
  name: 'premiumRegister',
  initialState: {
    industryList: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIndustry.fulfilled, (state, action) => {
      return {
        industryList: action.payload.industry_list
      };
    });
  }
});

export const industryList = (state) => state.premiumRegister.industryList;
export default premiumRegister.reducer;
